import { Observable } from 'rxjs';

import { ConsentForm, ConsentFormQueryParams } from '../models/consent-form.model';
import { ListResponse } from '../models/utility.model';

export abstract class ConsentFormGateway {
  abstract listConsentForms(params: ConsentFormQueryParams): Observable<ListResponse<ConsentForm>>;
}
